import React from 'react';

const ContextMenuContainer = ({pageId}) => {
  return (
    <div
      id={`context-menu-container-${pageId}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 999999,
        width: 0,
        height: 0,
        overflow: 'visible',
      }}
    />
  );
};

export default ContextMenuContainer;
